<div class="table-width" style="overflow: hidden;">
  <div class="row" style="margin: 20px;">
    <div class="col-md-6">
      <h1> FFL Images</h1>
    </div>
  </div>
  
  <div class="grid-container" >
    <div class="grid-item" *ngFor="let row of fflImageList" [style.background]="checkBgColor(row.expiryDate)" >
       <div class="items">
         <div class="item">
             <img class="img" [src]="row.image ? 'data:image/jpg;base64,' + row.image : 'assets/Images/demo1.png'" alt="">
           <p class="text-2">Room Name : {{row?.roomName}}</p>
           <p class="text-3">Room Owner : {{row?.onwerName}}</p>    
           <p class="text-3">Expiry Date : {{row.expiryDate | date:'mediumDate'}}</p>        
         </div>
       </div> 
     </div>
   </div>
</div>